<template>
  <div id="UserInfoMenu">
    <p class="user-info-label m-0">Hello</p>
    <button ref="userInfoMenu" class="user-info" @click="toggleMenu">
      <span class="hide-on-mobile brand-highlight-3">{{ userName }}</span>
      <img
        src="/img/my-health/user-account.png"
        alt="User icon"
        class="user-img"
      />
      <img
        src="/img/my-health/arrow-down.svg"
        alt="Arrow down"
        class="user-img hide-on-mobile"
      />

      <div v-show="isMenuShown" class="user-menu">
        <ul v-if="headerMenuItems" class="p-0 m-0">
          <li
            v-for="(item, key) in headerMenuItems.links"
            :key="key"
            class="user-menu-item"
          >
            <a
              :href="item.url"
              :target="headerMenuItems.opensInNewTab ? '_blank' : '_self'"
              >{{ item.label }}</a
            >
          </li>
        </ul>
        <div class="user-menu-item last">
          <a
            class="user-menu-sign-out"
            @click="signOut"
            href="https://www.simplyhealth.co.uk/member-portal/signOut"
          >
            <img src="/img/my-health/sign-out.svg" alt="Sign out icon" />
            <span class="ml-1">Sign out</span>
          </a>
        </div>
      </div>
    </button>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "UserInfoMenu",
  data() {
    return {
      isMenuShown: false
    };
  },
  mounted() {
    document.addEventListener("click", this.handleOutsideClick);
  },
  beforeDestroy() {
    document.removeEventListener("click", this.handleOutsideClick);
  },
  computed: {
    ...mapState(["navigationTags"]),
    headerMenuItems() {
      return this.navigationTags?.headerMenu || null;
    },
    userName() {
      const firstName = this.$store.getters.user.user?.first_name.trim();
      const lastName = this.$store.getters.user.user?.last_name.trim();
      return lastName ? `${firstName} ${lastName}` : `${firstName}`;
    }
  },
  methods: {
    toggleMenu() {
      this.isMenuShown = !this.isMenuShown;
    },
    signOut() {
      this.$store.dispatch("logout");
    },
    handleOutsideClick(event) {
      if (this.isMenuShown && !this.$refs.userInfoMenu.contains(event.target)) {
        this.isMenuShown = false;
      }
    }
  }
};
</script>

<style lang="less">
#UserInfoMenu {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;

  .user-info-label {
    color: #fff;
    font-size: 1.8rem;
    font-family: "PlusJakartaSansBold";
  }

  .user-info {
    border: none;
    position: relative;
    display: flex;
    align-items: center;
    background-color: #57efd0;
    border-radius: 20px;
    padding: 8px 16px;
    font-size: 1.8rem;
    font-family: "PlusJakartaSansBold";
  }

  .user-menu {
    position: absolute;
    top: calc(100% + 16px);
    left: 50%;
    transform: translateX(-50%);
    width: 160px;
    z-index: 100;
    border: 2px solid #e0e5f5;
    border-radius: 4px;
    background-color: #fff;
    margin: 0;
    padding: 0;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

    &::before {
      content: "";
      position: absolute;
      top: -11px;
      left: 76%;
      transform: translateX(-50%);
      border-left: 16px solid transparent;
      border-right: 16px solid transparent;
      border-bottom: 12px solid #fff;
      z-index: 101;
    }

    .user-menu-item {
      list-style: none;
      font-family: "PlusJakartaSansRegular";
      border-bottom: 1px solid #e0e5f5;
      padding: 10px;
      text-align: left;
      border-radius: 4px;

      &:hover, &:focus {
        background-color: #f2f4f8;
      }

      &.last {
        cursor: default;

        &:hover, &:focus {
          background-color: #fff;
        }
      }
    }

    .user-menu-sign-out {
      background-color: #abf7e8;
      padding: 6px 10px;
      color: #000;
      font-size: 1.6rem;
      letter-spacing: 0;
      font-family: "PlusJakartaSansRegular";
      text-align: center;
      border-radius: 40px;

      &:hover, &:focus {
        color: #000;
      }
    }

    a {
      color: #000;
      line-height: 2rem;
      font-size: 1.6rem;

      &:hover {
        color: #000;
      }
    }
  }

  .user-img {
    width: 24px;
    height: 24px;
    object-fit: contain;
    margin-left: 8px;
  }
}

@media screen and (max-width: 767px) {
  #UserInfoMenu {
    .user-info-label {
      display: none;
    }

    .user-info {
      background-color: transparent;
      padding: 0;
    }

    .hide-on-mobile {
      display: none;
    }

    .user-menu {
      right: -80%;
      left: unset;
      transform: none;
    }
  }
}
</style>
